import {configureStore, getDefaultMiddleware} from "@reduxjs/toolkit";
import loyaltySlice from "./Slices/LoyaltySlice";


export default configureStore({
    reducer: {
        loyalty: loyaltySlice,
    },
    middleware: getDefaultMiddleware({serializableCheck: false}),
});